var bumpyBaseUrl = process.env.REACT_APP_BUMPYFILE_BASE_URL || "https://bumpyfile.leadsherpa.com";
var bumpyPublishableKey = process.env.REACT_APP_BUMPYFILE_PUBLISHABLE_KEY || "bf_pk_dev_leadsherpa";
export function getBumpyApiBaseUrl() {
    return bumpyBaseUrl;
}
export function getBumpyPublishableKey() {
    return bumpyPublishableKey;
}
var key = function (value) { return value; };
var field = function (fieldKey, fieldLabel, fieldKind, fieldAlternativeNames) { return ({
    fieldKey: key(fieldKey),
    fieldLabel: fieldLabel,
    fieldKind: fieldKind,
    fieldRequired: "Optional",
    fieldAlternativeNames: fieldAlternativeNames,
    fieldMaxLength: null,
}); };
export var skipSherpaImportSchema = {
    schemaKey: "skipsherpa_file_import",
    schemaDisplayName: "SkipSherpa file import",
    schemaSubmitMode: "PreserveAllRows",
    schemaFields: [
        field("street", "Street", "TextField", [
            "street",
            "address",
            "property street",
            "property address",
        ]),
        field("street2", "Street 2", "TextField", [
            "unit",
            "suite",
            "street 2",
            "address 2",
            "property unit",
            "property suite",
        ]),
        field("city", "City", "TextField", ["city", "property city"]),
        field("state", "State", "UsStateField", ["state", "property state"]),
        field("zipcode", "Zipcode", "ZipCodeField", [
            "zip",
            "zipcode",
            "postal code",
            "property zip",
            "property zipcode",
        ]),
        field("mailing_street", "Mailing street", "TextField", [
            "mailing street",
            "mailing address",
            "owner address",
            "owner mailing address",
        ]),
        field("mailing_street2", "Mailing street 2", "TextField", [
            "mailing unit",
            "mailing suite",
            "owner unit",
            "owner suite",
        ]),
        field("mailing_city", "Mailing city", "TextField", ["mailing city", "owner city"]),
        field("mailing_state", "Mailing state", "UsStateField", ["mailing state", "owner state"]),
        field("mailing_zipcode", "Mailing zipcode", "ZipCodeField", [
            "mailing zip",
            "mailing zipcode",
            "owner zip",
            "owner zipcode",
        ]),
        field("first_name", "First name", "TextField", ["first", "first name", "owner first name"]),
        field("middle_name", "Middle name", "TextField", [
            "middle",
            "middle name",
            "owner middle name",
        ]),
        field("last_name", "Last name", "TextField", ["last", "last name", "owner last name"]),
        field("age", "Age", "TextField", ["age"]),
        field("phone_number", "Phone number", "PhoneField", ["phone", "phone number", "mobile"]),
        field("email", "Email", "EmailField", ["email", "email address"]),
        field("business_name", "Business name", "TextField", ["business", "company", "business name"]),
        field("apn", "APN", "ApnField", [
            "apn",
            "property apn",
            "parcel",
            "parcel number",
            "assessor parcel number",
        ]),
        field("fips", "FIPS", "FipsField", ["fips", "fips code", "property fips"]),
        field("county", "County", "TextField", ["county", "county name", "property county"]),
    ],
    schemaValidationRules: [],
    schemaPreserveOriginalColumns: false,
    schemaIncludeUnmatchedDefault: false,
};
export function buildBumpySession(accountId, userId, objectPrefix) {
    return {
        csrTenantId: "skipsherpa",
        csrConsumerAppId: "skipsherpa_web",
        csrAccountId: accountId,
        csrUserId: userId,
        csrSchema: skipSherpaImportSchema,
        csrAllowedOrigin: window.location.origin,
        csrCallbackUrl: null,
        csrPreserveOriginalFile: true,
        csrPreserveFinalFile: true,
        csrS3ObjectPrefix: objectPrefix !== null && objectPrefix !== void 0 ? objectPrefix : null,
        csrTheme: {
            themeName: "Skip Sherpa",
            themeLogoUrl: null,
            themeSubmitText: "Use this file",
            themeRules: {
                background: "#2563eb",
                color: "#ffffff",
            },
        },
    };
}
export function normalizeColumnNames(columns) {
    return columns
        .map(function (column) {
        var _a;
        if (typeof column === "string")
            return column;
        if (column && typeof column === "object" && "unColumnName" in column) {
            return String((_a = column.unColumnName) !== null && _a !== void 0 ? _a : "");
        }
        return String(column !== null && column !== void 0 ? column : "");
    })
        .map(function (column) { return column.trim(); })
        .filter(Boolean);
}
export function submitDataColumnNames(data) {
    var _a, _b;
    return normalizeColumnNames((_b = (_a = data.submitColumnNames) !== null && _a !== void 0 ? _a : data.columnNames) !== null && _b !== void 0 ? _b : []);
}
export function parseRanges(value) {
    return value
        .split(",")
        .map(function (part) { return part.trim(); })
        .filter(Boolean)
        .flatMap(function (part) {
        var _a = part.split("-").map(function (token) { return Number.parseInt(token.trim(), 10); }), startRaw = _a[0], endRaw = _a[1];
        if (!Number.isFinite(startRaw))
            return [];
        var end = Number.isFinite(endRaw) ? endRaw : startRaw;
        return [{ start: Math.max(0, startRaw - 1), end: Math.max(0, end - 1) }];
    });
}
